<template>
  <canvas ref="canvas" class="gx-space" :style="{ opacity }"></canvas>
</template>

<script>
/**
 * 轻量星空（无流星或低频流星），用于页面区块背景
 */
export default {
  name: 'SpaceCanvas',
  props: {
    opacity: { type: Number, default: 0.4 }
  },
  data() {
    return {
      raf: 0,
      W: 0,
      H: 0,
      stars: [],
      mt: 0,
      meteors: []
    }
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
    this.raf = requestAnimationFrame(this.draw)
  },
  beforeDestroy() {
    cancelAnimationFrame(this.raf)
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    resize() {
      const c = this.$refs.canvas
      if (!c) return
      const ctx = c.getContext('2d')
      if (!ctx) return
      this.W = c.offsetWidth
      this.H = c.offsetHeight
      c.width = this.W * window.devicePixelRatio
      c.height = this.H * window.devicePixelRatio
      ctx.scale(window.devicePixelRatio, window.devicePixelRatio)
      this.stars = Array.from({ length: 60 }, () => ({
        x: Math.random() * this.W,
        y: Math.random() * this.H,
        r: 0.3 + Math.random() * 1.8,
        p: Math.random() * Math.PI * 2,
        sp: 0.15 + Math.random() * 0.6
      }))
    },
    draw(t) {
      const c = this.$refs.canvas
      if (!c) return
      const ctx = c.getContext('2d')
      ctx.clearRect(0, 0, this.W, this.H)
      this.stars.forEach((s) => {
        const o = 0.1 + 0.6 * (0.5 + 0.5 * Math.sin(s.p + t * s.sp * 0.002))
        ctx.beginPath()
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2)
        ctx.fillStyle = `rgba(255,255,255,${o})`
        ctx.fill()
      })
      this.mt++
      if (this.mt > 1800 && this.meteors.filter((m) => m.ok).length < 1) {
        const sp = 6 + Math.random() * 6
        this.meteors.push({
          x: this.W * 0.5 + Math.random() * this.W * 0.4,
          y: -10,
          vx: -Math.cos(0.6) * sp,
          vy: Math.sin(0.6) * sp,
          l: 140,
          life: 0,
          max: 50,
          ok: true
        })
        this.mt = 0
      }
      this.meteors = this.meteors.filter((m) => m.ok || m.life < m.max + 3)
      this.meteors.forEach((m) => {
        if (!m.ok) return
        m.x += m.vx
        m.y += m.vy
        m.life++
        const a = Math.min(1, (m.max - m.life) / 10)
        if (a <= 0) { m.ok = false; return }
        const g = ctx.createLinearGradient(m.x, m.y, m.x - m.vx * 14, m.y - m.vy * 14)
        g.addColorStop(0, `rgba(255,225,100,${a})`)
        g.addColorStop(1, 'transparent')
        ctx.beginPath()
        ctx.moveTo(m.x, m.y)
        ctx.lineTo(m.x - m.vx * 14, m.y - m.vy * 14)
        ctx.strokeStyle = g
        ctx.lineWidth = 2
        ctx.stroke()
      })
      this.raf = requestAnimationFrame(this.draw)
    }
  }
}
</script>

<style scoped>
.gx-space {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
